import React from "react";
import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-[#E6E3DB] py-10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-3 gap-6 items-center text-sm text-[#787671]">
        <p data-testid="footer-copyright">
          © {new Date().getFullYear()} Financial Habits to Succeed.{" "}
          <span className="whitespace-nowrap">All rights reserved.</span>
        </p>
        <nav className="flex items-center gap-4 md:gap-6 flex-wrap justify-self-start md:justify-self-center">
          <Link to="/about" className="hover:text-[#2C302E]" data-testid="footer-about-link">About</Link>
          <Link to="/contact" className="hover:text-[#2C302E]" data-testid="footer-contact-link">Contact</Link>
          <a href="/#pricing" className="hover:text-[#2C302E]">Pricing</a>
          <Link to="/ynab-alternative" className="hover:text-[#2C302E]" data-testid="footer-compare-link">Compare</Link>
          <Link to="/balance-calculator" className="hover:text-[#2C302E]" data-testid="footer-calculator-link">Calculator</Link>
          <a
            href={`${process.env.REACT_APP_BLOG_URL || "https://finhabits.blogspot.com/"}?utm_source=finhabits-app&utm_medium=footer-nav&utm_campaign=blog_link`}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#2C302E]"
            data-testid="footer-blog-link"
          >
            Blog
          </a>
          <Link to="/privacy" className="hover:text-[#2C302E]" data-testid="footer-privacy-link">Privacy</Link>
          <Link to="/terms" className="hover:text-[#2C302E]" data-testid="footer-terms-link">Terms</Link>
          <a
            href="https://www.instagram.com/finhabits1/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 hover:text-[#2C302E]"
            aria-label="Follow Finhabits on Instagram"
            data-testid="footer-instagram-link"
          >
            <Instagram className="h-4 w-4" />
            <span>@finhabits1</span>
          </a>
        </nav>
        <p className="md:text-right">Private by default. Cancel anytime.</p>
      </div>
    </footer>
  );
}
